function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { Notification } from "../Notification";

// Local Definitions

import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'notification-stack';
const NotificationStack = ({
  id,
  className: userClassName,
  style,
  notifications,
  maxNotifications,
  ...otherProps
}) => {
  const notificationsToDisplay = notifications.slice(0, maxNotifications);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, otherProps), notificationsToDisplay.map(notification => /*#__PURE__*/React.createElement(Notification, _extends({
    key: notification?.id || notification.message
  }, notification))));
};
NotificationStack.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The list of notifications to display
   */
  notifications: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    color: PropTypes.string,
    message: PropTypes.string,
    type: PropTypes.string,
    isVisible: PropTypes.bool,
    closeNotification: PropTypes.func
  })),
  /**
   * The maximum number of notifications to display
   */
  maxNotifications: PropTypes.number
};
NotificationStack.defaultProps = {
  maxNotifications: 5
};
export default NotificationStack;